import RestAPI from "./RestApiConsumer";
import { API_BASE_URL } from "constants/index";

export const api = new RestAPI(API_BASE_URL);

//Login Controller
api.addEndpoint("login", undefined, "POST", false);
api.addRichParametersEndpoint(
  "users/generate-code",
  "generateCode",
  "POST",
  false
);
api.addEndpoint("users/new-password", "newPassword", "POST", false);
api.addEndpoint("users/reset-password", "resetPassword", "POST", true);

//Users

api.addEndpointWithParams("users", "getUsers", "GET", true);
api.addEndpoint("users", "saveUser", "POST", true);
api.addEndpoint("users", "putUser", "PUT", true);
api.addRichParametersEndpoint("users", "deleteUser", "DELETE", true);
api.addRichParametersEndpoint("users", "getById", "GET", true);

//Managerial
api.addRichParametersEndpoint("managerial", "getData", "GET", true);
api.addEndpoint("managerial/save", "saveData", "POST", true);
api.addRichParametersEndpoint("managerial", "deleteByType", "DELETE", true);

//Managerial Company
api.addEndpointWithParams("managerial/companies", "getCompanies", "GET", true);
api.addEndpoint("managerial/companies", "saveCompany", "POST", true);
api.addRichParametersEndpoint(
  "managerial/companies",
  "updateCompany",
  "PATCH",
  true
);

api.addRichParametersEndpoint(
  "managerial/companies",
  "deleteCompany",
  "DELETE",
  true
);
api.addRichParametersEndpoint(
  "managerial/companies",
  "getComments",
  "GET",
  true
);
api.addRichParametersEndpoint(
  "managerial/companies",
  "saveComments",
  "POST",
  true
);

api.addRichParametersEndpoint(
  "managerial/companies",
  "getDocuments",
  "GET",
  true
);

api.addRichParametersEndpoint(
  "managerial/companies",
  "saveDocuments",
  "POST",
  true,
  true
);
api.addRichParametersEndpoint(
  "managerial/companies",
  "deleteDocuments",
  "DELETE",
  true
);

//Login
export const userService = {
  login: api.endpoints.login,
  generateCode: api.endpoints.generateCode,
  newPassword: api.endpoints.newPassword,
  resetPassword: api.endpoints.resetPassword,
};

//Users
export const userAdminService = {
  getUsers: api.endpoints.getUsers,
  saveUser: api.endpoints.saveUser,
  putUser: api.endpoints.putUser,
  deleteUser: api.endpoints.deleteUser,
  getById: api.endpoints.getById,
};

//Manegerial
export const managerialService = {
  getData: api.endpoints.getData,
  saveData: api.endpoints.saveData,
  deleteByType: api.endpoints.deleteByType,
  saveCompany: api.endpoints.saveCompany,
  getCompanies: api.endpoints.getCompanies,
  deleteCompany: api.endpoints.deleteCompany,
  updateCompany: api.endpoints.updateCompany,
  getComments: api.endpoints.getComments,
  saveComments: api.endpoints.saveComments,
  getDocuments: api.endpoints.getDocuments,
  saveDocuments: api.endpoints.saveDocuments,
  deleteDocuments: api.endpoints.deleteDocuments,
};
const Services = {
  userService,
  userAdminService,
  managerialService,
};

export default Services;
